import {Routes, Route, Navigate} from "react-router-dom";
import {SidebarProvider, SidebarInset, SidebarTrigger} from "@/components/ui/sidebar";
import {AppSidebar} from "@/components/layout/app-sidebar";
import {ChatPage} from "@/pages/chat-page";
import {MainPage} from "@/pages/main-page";
import {FavoritesPage} from "@/pages/favorites-page";
import {InfluenceMapPage} from "@/pages/influence-map";
import {PostPage} from "@/pages/post-page";
import {AuroraBackground} from "./components/ui/shadcn-io/aurora-background";

function App() {
  return (
    <SidebarProvider defaultOpen={true} className="h-svh overflow-hidden">
      <AppSidebar />
      <SidebarInset>
        <AuroraBackground>
          <div className="bg-background/85 text-foreground absolute inset-0 z-10 flex flex-col">
            <header className="bg-background/70 sticky top-0 z-50 flex h-14 shrink-0 items-center gap-2 border-b border-white/10 px-4 backdrop-blur-xl md:hidden">
              <SidebarTrigger className="-ml-1" />
            </header>
            <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
              <Routes>
                <Route path="/home" element={<MainPage />} />
                <Route path="/chat" element={<ChatPage />} />
                <Route path="/favorites" element={<FavoritesPage />} />
                <Route path="/influence-map" element={<InfluenceMapPage />} />
                <Route path="/post/:id" element={<PostPage />} />
                {/* Redirect any other protected routes to home */}
                <Route path="*" element={<Navigate to="/home" replace />} />
              </Routes>
            </div>
          </div>
        </AuroraBackground>
      </SidebarInset>
    </SidebarProvider>
  );
}

export default App;
